import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

import { Typography, Slide, IconButton } from '@material-ui/core/';
import CloseIcon from '@material-ui/icons/Close';

import ContentStoragePark from './content/ContentStoragePark';
import ContentLoadPeakHistoric from './content/ContentLoadPeakHistoric';
import ContentLoadPeakCurrent from './content/ContentLoadPeakCurrent';
import PvAnalageContent from './content/ContentSolarEnergy';
import ContentPerformance from './content/ContentPerformance';
import ContentStorageCab from './content/ContentStorageCab';
import ContentPowerMarketing from './content/ContentPowerMarketing';

const Root = styled.div`
	position: absolute;
	top: 0;
	left: 0;
	bottom: 0;
	width: 50%;
	background-color: ${(props) =>
		props.theme.palette.blocks.graph.overlay.backgroundColor};
	z-index: 999;

	.panel-head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		padding: 20px;

		h6 {
			font-size: 16px;
			font-weight: bold;
			text-transform: uppercase;
		}

		button {
			color: ${(props) => props.theme.palette.text.primary};
		}
	}
`;

const GraphOverLayEvaluation = ({ toggle, SlideIn, valueLink, activeCase, data }) => {
	const [
		energyConsumptionDataWithoutBattery,
		setEngeryConsumptionDataWithoutBattery,
	] = useState(0);

	const [
		energyConsumptionDataWithBattery,
		setenergyConsumptionDataWithBattery,
	] = useState(0);

	const [co2reduction, setCo2reduction] = useState([{ historisch: 0, aktuell: 0 }]);

	useEffect(() => {
		if (activeCase) {
			setEngeryConsumptionDataWithoutBattery(data.kpis.without_battery.peak);
			setenergyConsumptionDataWithBattery(data.kpis.with_battery.peak);
		} else {
			setEngeryConsumptionDataWithoutBattery(
				data.kpis.without_pv_battery.energy_consumption
			);
			setenergyConsumptionDataWithBattery(
				data.kpis.with_pv_battery.energy_consumption
			);
			setCo2reduction([
				{
					historisch: data.kpis.without_pv_battery.co2,
					aktuell: data.kpis.with_pv_battery.co2,
				},
			]);
		}
	}, [data]); // eslint-disable-line react-hooks/exhaustive-deps

	// API Hint
	// active Case == Netzentgelte (true) / Eigenverbrauch (false)
	// Stromverbrauch Historisch === always WITHOUT_Battery (kpis.without_pv_battery)
	// Stromverbrauch Aktuell === always with_Battery (kpis.with_pv_battery)
	// C02 Savings / C02 gibt es nur bei Eigenvebrauch! (activeCase === falses)

	let component = null;
	switch (valueLink) {
		case 'Strombezug historisch':
			component = (
				<ContentLoadPeakHistoric
					activeCase={activeCase}
					co2reduction={co2reduction[0].historisch}
					counterNumber={energyConsumptionDataWithoutBattery}
				/>
			);
			break;
		case 'Strombezug aktuell':
			component = (
				<ContentLoadPeakCurrent
					activeCase={activeCase}
					co2reduction={co2reduction[0].aktuell}
					counterNumber={energyConsumptionDataWithBattery}
				/>
			);
			break;
		case 'PV Anlage':
			component = (
				<PvAnalageContent
					kwPeak={data.pv_size === undefined ? 0 : data.pv_size}
				/>
			);
			break;
		case 'scalebloc':
			component = <ContentStorageCab />;
			break;
		case 'scalecube':
			component = <ContentStoragePark />;
			break;
		case 'Zielleistung':
			component = (
				<ContentPerformance
					counterNumber={
						energyConsumptionDataWithoutBattery -
						energyConsumptionDataWithBattery
					}
				/>
			);
			break;
		case 'Stromvermarktung':
			component = <ContentPowerMarketing />;
			break;
		default:
			component = null;
			break;
	}

	return (
		<Slide direction="right" in={SlideIn} mountOnEnter>
			<Root>
				<div className="panel-head">
					<Typography variant="h6">{valueLink}</Typography>
					<IconButton onClick={toggle}>
						<CloseIcon />
					</IconButton>
				</div>
				<div className="panel-content">{component}</div>
			</Root>
		</Slide>
	);
};

export default GraphOverLayEvaluation;
